import React from "react"
import {Button, Grid, Icon, Message, Segment} from "semantic-ui-react"
import {Link} from "react-router-dom"
import MFR from "../presentation/MFR"
import api from "../api"
import TopNavigation from "./components/TopNavigation"
import SignaturesOverview from "./components/SignaturesOverview"

const {signatureStore} = api
import {useTranslation, Trans} from 'react-i18next'

const HomePage = () => {
    let order = api.getOrder()
    let appointment = api.getAppointment()
    let isRejected = order.StateCode === "eRejected"

    const {signatures} = signatureStore
    const {t} = useTranslation();
    const apiSteps = api.getSteps().length;

    // let progress    = api.getProgress()
    let message = isRejected ? <Message negative>
        <Message.Header>{t("job.hold")}</Message.Header>
        <p>{t("job.the")} {t("general.rejected")} {t("general.orIsIn")} {t("general.escalationManagement")}</p>
    </Message> : null

    return (
        <div>
            <TopNavigation/>
            <div className="transition-item section-full section--center ph2 ">
                {message}
                {/*{progress === 100 ? <div className="tr">*/}
                {/*<Link to="/sign">*/}
                {/*<Button size="small" color="green">Überprüfen und abschließen<Icon*/}
                {/*name="chevron right"/></Button>*/}
                {/*</Link>*/}
                {/*</div> : null}*/}

                <Segment textAlign="center">
                    <div className="pt4 pb3">
                        <Button className="pb3" basic size="huge" circular icon="info"/>
                        <div className="pa3">
                            <Trans i18nKey="report.generate">
                                Erstellen Sie Ihren Bericht in <strong>{{apiSteps}} Schritten</strong>
                            </Trans>
                        </div>
                        <Continue to="/tasks" title={t('report.edit')} icon="chevron right"/>
                    </div>
                </Segment>

                <Segment.Group>
                    <TitleBlock order={order}
                                event={appointment}/>
                    <Segment>
                        <Segment.Group>
                            <Segment>
                                <Grid stretched columns={2}>
                                    <Grid.Column>
                                        <MFR.Title>{t('general.description')}</MFR.Title>
                                        {(order.Description) ? <p className="order-description"
                                                                  dangerouslySetInnerHTML={{__html: order.Description}}/> :
                                            <p>...</p>}
                                    </Grid.Column>
                                    <Grid.Column className="tr">
                                        <div>{order.CurrentOwner.FirstName}&nbsp;{order.CurrentOwner.LastName} {order.CurrentOwner.Company &&
                                            <span>({order.CurrentOwner.Company.Name})</span>}</div>
                                        {order.CurrentOwner.Telephone &&
                                            <div><Icon name="phone"/> {order.CurrentOwner.Telephone}</div>}
                                        {order.CurrentOwner.MobilePhone &&
                                            <div><Icon name="mobile"/> {order.CurrentOwner.MobilePhone}</div>}
                                        {order.CurrentOwner.Email &&
                                            <div><Icon name="mail"/> {order.CurrentOwner.Email}</div>}
                                    </Grid.Column>
                                </Grid>
                            </Segment>
                            <Segment><LocationBlock order={order}/></Segment>
                            <ContactPersons/>
                        </Segment.Group>
                        <Segment stacked> <TodoBlock order={order}/></Segment>
                        {(order.Documents && order.Documents.length) > 0 ?
                            <Segment stacked> <DocumentsBlock order={order}/> </Segment> : null}
                    </Segment>
                </Segment.Group>

                <SignaturesOverview signatures={signatures}/>
            </div>
        </div>
    )
}
export default HomePage

const ContactPersons = () => {
    let contactSegments = api.getContactPersons()
        .map(contact => <Segment key={contact.Id}><ContactBlock
            person={contact}/></Segment>)

    const {t} = useTranslation();

    return (
        <Segment>
            <MFR.Title>{t('general.contact')}</MFR.Title>
            <Segment.Group>
                {contactSegments}
            </Segment.Group>
        </Segment>
    )
}

const ContactBlock = ({person} = {}) => {
    let company = person.Company || {}

    return (
        <div>
            <div>{person.FirstName}&nbsp;{person.LastName} ({company.Name})</div>
            {person.Telephone && <div><Icon name="phone"/> {person.Telephone}</div>}
            {person.MobilePhone && <div><Icon name="mobile"/> {person.MobilePhone}</div>}
            {person.Email && <div><Icon name="mail"/> {person.Email}</div>}
        </div>
    )
}

const DateBlock = ({event}) => {
    const {t} = useTranslation();

    return (
        <div>
            <MFR.Title>{t('intlDateTime', {
                val: new Date(event.StartDateTime),
                formatParams: {
                    val: { year: 'numeric', month: 'long', day: 'numeric' },
                },
            })}</MFR.Title>
            <div>{api.formatDate(event.StartDateTime, "HH:mm")} {t("general.to")} {api.formatDate(event.EndDateTime, "HH:mm")}</div>
        </div>
    )
}


const TitleBlock = ({order, event}) => {
    const {t} = useTranslation();
    return (
        <Segment>
            <div className="fr">
                <div className="f4 strong">
                    {t('intlDateTime', {
                        val: new Date(event.StartDateTime),
                        formatParams: {
                            val: { year: 'numeric', month: 'long', day: 'numeric' },
                        },
                    })}</div>
                <div className="text-right">{api.formatDate(event.StartDateTime, "HH:mm")} {t("general.to")} {api.formatDate(event.EndDateTime, "HH:mm")}</div>
            </div>
            <div className="">
                <div className="f3 strong">{order.ExternalId}</div>
                <div>{order.Name}</div>
            </div>
        </Segment>
    )
}

const LocationBlock = ({order}) => {
    if (!order.Location) return null

    const {t} = useTranslation();

    return (
        <div>
            <Grid stretched columns={2}>
                <Grid.Column>
                    <MFR.Title>{t("general.serviceObject")}</MFR.Title>
                    {order.Location ?
                        <span> {order.Location.AddressString}, {order.Location.Postal}&nbsp;{order.Location.City}</span> : null}
                </Grid.Column>
                <Grid.Column className="tr">
                    <a
                        href={`https://maps.google.com?q=${order.Location.AddressString}+${order.Location.Postal}+${order.Location.City}`}
                        target="_blank"> <Button basic color="grey"> {t("general.showPlace")}</Button>
                    </a>
                </Grid.Column>
            </Grid>
        </div>
    )
}

const TodoBlock = ({order}) => {

    const {t} = useTranslation();

    return (
        <div>
            <Grid stretched
                  columns={2}>
                <Grid.Column>
                    <MFR.Title>{t("general.report")}</MFR.Title>
                    <div>{api.getFinishedSteps()}/{api.getSteps().length}</div>
                </Grid.Column>
                <Grid.Column className="tr">
                    <Link to="/tasks">
                        <Button basic color="grey">{t("general.edit")}</Button></Link>
                </Grid.Column>
            </Grid>
        </div>
    )
}


const DocumentsBlock = ({order}) => {
    let all = api.getAllAttachments()
    if (all.documents.length === 0) return null

    const {t} = useTranslation();
    const documentCount = all.documents.length;

    return (
        <div>
            <Grid stretched
                  columns={2}>
                <Grid.Column>
                    <MFR.Title>{t("general.attachments")}</MFR.Title>
                    <div>{t("general.attachment", {count: documentCount})}</div>
                </Grid.Column>
                <Grid.Column className="tr">
                    <Link to="/documents"><Button basic color="grey">{t("general.show")}</Button></Link>
                </Grid.Column>
            </Grid>
        </div>
    )
}

const DescriptionBlock = ({order}) => (
    <div>
        <p dangerouslySetInnerHTML={{__html: order.Description}}/>
    </div>
)

const Continue = ({to, title = "<Trans i18nKey=\"general.next\">Weiter</Trans>", icon = "chevron right"}) => (
    <div className="">
        <Link to={to}><Button className="no-margin-right" color='green'>{title}<Icon name={icon}/></Button></Link>
    </div>
)

export {DescriptionBlock, ContactPersons, DocumentsBlock, ContactBlock, LocationBlock, TodoBlock, TitleBlock, DateBlock}



// WEBPACK FOOTER //
// ./src/pages/HomePage.js